import {
	type Accessor,
	createContext,
	type ParentComponent,
	useContext,
} from "solid-js";

/**
 * Whether the viewer may report the videos rendered inside. Reporting is for
 * signed-in viewers only, so a page enables it from its own sign-in state.
 */
const OffersVideoReportContext = createContext<Accessor<boolean>>(() => false);

export const OffersVideoReportProvider: ParentComponent<{
	enabled: boolean;
}> = (props) => (
	<OffersVideoReportContext.Provider value={() => props.enabled}>
		{props.children}
	</OffersVideoReportContext.Provider>
);

export const useOffersVideoReport = (): Accessor<boolean> =>
	useContext(OffersVideoReportContext);
